<template>
  <div class="container">
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">مدیریــت {{ PersianName }}ها</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row pr-4">
          <h3>
            <i v-if="!AddMode" class="fas Pointer fa-plus text-success" @click="changeAdd"></i>
            <i v-else class="fas fa-times Pointer text-danger" @click="changeAdd"></i>
          </h3>
        </div>
        <div v-if="AddMode" class="row">
          <div class="col-lg-6 col-12">
            <small>توضیحات {{ PersianName }}</small>
            <input type="text" v-model="DataAxios.ArryfildValue.parentFormId" class="form-control" />
          </div>
          <div class="col-lg-6 col-12">
            <Uploader @upload="GetUpload"> </Uploader>
          </div>
          <div class="col-lg-6 col-12">
            <small v-if="EnglishName == 'File' && $session.get('Menu').filter((x) => x.RouteName == 'ViewCustomerFiles')[0].isMojaz == 1">انتخاب مشتری خاص برای فایل</small>
            <article v-if="EnglishName == 'File' && $session.get('Menu').filter((x) => x.RouteName == 'ViewCustomerFiles')[0].isMojaz == 1">
              <SearchableCombo
                :edit="false"
                :grp="0"
                :code="null"
                @ResultCombo="GetResulTblCostomer"
                :rownumintable="3"
                :defaultvalue="DataAxios.ArryfildValue.masterId"
                :action="'TblCrmCombo/GetCostomerProduct'"
                :method="'POST'"
                :idinput="'TblCostomer'"
                :keyItem="'TblCostomer'"
                :disabled="false"
                :ClassProps="'required'"
              >
              </SearchableCombo>
            </article>
          </div>
          <div class="col-lg-6 col-12 mt-2 p-3">
            <div class="row px-4">
              <div class="col-4"></div>
              <div class="col-8" v-if="isLoading == false">
                <button v-if="!editMode" @click="UploadEducation" class="btn btn-success w-100">بارگــذاری {{ PersianName }}</button>
                <button v-else @click="UploadEducation" class="btn btn-danger w-100">بروزرســانی {{ PersianName }}</button>
              </div>
              <div class="col-8 d-flex justify-content-center" v-else>
                <b-spinner variant="primary" label="Spinning" ></b-spinner>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!AddMode" class="row">
          <EducationTable :tablename="EnglishName" :IsModir="true" :label="'موضوع ' + PersianName" @edit="editRow"></EducationTable>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import Uploader from '@/components/Uploader/Uploader.vue'
import EducationTable from './educationTable.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
  props: ['PersianName', 'EnglishName'],
  data() {
    return {
      AddMode: false,
      DataAxios: {
        Action: 'CrmFile/Add',
        Method: 'POSt',
        ArryfildValue: {},
      },
      empty: {
        Id: 5,
        filename: '',
        Filepath: this.EnglishName,
        Binary: null,
        TableName: this.EnglishName,
        MasterId: 0,
        parentFormId: '',
        Dbname: 'CRM',
        ZamanInsert: '',
        TblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
        TblUserGrpIdLastEdit: null,
        ZamanLastEdit: '',
      },
      editMode: false,
      isLoading: false
    }
  },
  methods: {
    changeAdd() {
      this.editMode = false
      this.DataAxios.Action = 'CrmFile/Add'
      this.DataAxios.ArryfildValue = JSON.parse(JSON.stringify(this.empty))
      this.AddMode = !this.AddMode
    },
    GetUpload(file) {
      this.DataAxios.ArryfildValue.file = file
    },
    UploadEducation() {
      if (this.editMode) {
        this.DataAxios.Action = 'CrmFile/Edit'
        this.DataAxios.ArryfildValue.tblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
      }
      this.isLoading = true
      this.$PostFormData(this.DataAxios)
        .then((result) => {
          if (result.status == 'success') {
            if (this.editMode) {
              this.$mySweetDefaultTost('عملیات موفق', 'آموزش  با موفقیت ویرایش شد', 'success', 1000)
            } else {
              this.$mySweetDefaultTost('عملیات موفق', 'آموزش جدید با موفقیت بارگذاری شد', 'success', 1000)
            }
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', result.msg, 'warning', 1000)
          }
        })
        .catch(() => {
          this.$mySweetDefaultTost('خطایی رخ داده است', '', 'error', 1000)
        })
        .finally(() => {
          this.editMode = false
          this.AddMode = false
          this.isLoading = false 
        })
    },
    editRow(data) {
      // console.log(data)
      this.AddMode = true
      this.DataAxios.ArryfildValue = data
      this.DataAxios.ArryfildValue.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
      this.DataAxios.ArryfildValue.filename = this.DataAxios.ArryfildValue.filename.replace(this.DataAxios.ArryfildValue.id, '').replace(/\.[^/.]+$/, '')
      this.editMode = true
    },
    GetResulTblCostomer(data) {
      if (data.id != null || data.deleted) {
        this.DataAxios.ArryfildValue.MasterId = data.id
        this.DataAxios.ArryfildValue.masterId = data.id
      }
    },
  },
  components: { Card, Uploader, EducationTable, SearchableCombo },
}
</script>
<style></style>
